import React from 'react';
import axios from 'axios';
import { ReactSortable } from 'react-sortablejs';

export default function MediaGallery({ media, onRemove, onChange }) {
  const handleRemove = async (index) => {
    const item = media[index];
    if (!item.public_id) return;

    try {
      await axios.post('/api/upload/delete', {
        public_id: item.public_id,
        resource_type: item.type === 'video' ? 'video' : 'image',
      });

      const updated = [...media];
      updated.splice(index, 1);
      onRemove(updated);
    } catch (err) {
      console.error('❌ Failed to delete from Cloudinary:', err);
      alert('Could not delete media. Please try again.');
    }
  };

  console.log('🧩 Media passed to gallery:', media);

  return (
    <div className="space-y-6 mt-6">
      <h3 className="text-xl font-bold mb-4">Uploaded Media (Drag to Reorder)</h3>

      <ReactSortable
        list={media}
        setList={(newList) => onChange(newList)}
        className="grid grid-cols-2 md:grid-cols-3 gap-4"
      >
        {media.map((item, index) => {
          const resolvedType = item.type || (item.url?.includes('.mp4') ? 'video' : 'photo');

          return (
            <div key={item.public_id || index} className="relative border rounded p-2">
              {/* Main Photo Tag */}
              {index === 0 && (
                <span className="absolute top-1 left-1 bg-green-600 text-white text-xs px-2 py-1 rounded">
                  Main Photo
                </span>
              )}

              {/* Render Image or Video if URL is valid */}
              {resolvedType === 'photo' && item.url ? (
                <img
                  src={item.url}
                  alt={`Media ${index}`}
                  className="rounded w-full h-40 object-cover"
                  onError={() => console.warn('❌ Image failed to load:', item)}
                />
              ) : resolvedType === 'video' && item.url ? (
                <video
                  controls
                  src={item.url}
                  className="rounded w-full h-40 object-cover"
                  onError={() => console.warn('❌ Video failed to load:', item)}
                />
              ) : null}

              {/* Remove Button */}
              <button
                onClick={() => handleRemove(index)}
                className="absolute top-1 right-1 bg-red-500 text-white rounded-full px-2 py-1 text-xs hover:bg-red-600"
              >
                ✖
              </button>
            </div>
          );
        })}
      </ReactSortable>
    </div>
  );
}